/** Perfis da entidade Usuario */
export interface UsuarioPerfil {
    id: number;
    nome: string;
}

export const usuarioPerfilAdministrador: UsuarioPerfil = {id: 1, nome: 'Administrador'};
export const usuarioPerfilRepresentante: UsuarioPerfil = {id: 2, nome: 'Representante'};
export const usuarioPerfilGerente: UsuarioPerfil = {id: 3, nome: 'Gerente'};
export const usuarioPerfilAtendente: UsuarioPerfil = {id: 4, nome: 'Atendente'};
export const usuarioPerfilExpedicao: UsuarioPerfil = {id: 5, nome: 'Expedição'};
export const usuarioPerfilFinanceiro: UsuarioPerfil = {id: 6, nome: 'Financeiro'};
export const usuarioPerfilPCP: UsuarioPerfil = {id: 7, nome: 'PCP'};

export const usuarioPerfis: UsuarioPerfil[] = [
    usuarioPerfilAdministrador,
    usuarioPerfilAtendente,
    usuarioPerfilGerente,
    usuarioPerfilRepresentante,
    usuarioPerfilExpedicao,
    usuarioPerfilFinanceiro,
    usuarioPerfilPCP
];


/** Obtem o perfil do usuário através do id */
export function getUsuarioPerfil(id: number): UsuarioPerfil {
    if (!id) {
        return null;
    }
    return usuarioPerfis.find((value) => value.id === id);
}


/** Verifica se o perfil informado é igual ao perfil Administrador */
export function isPerfilAdministrador(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilAdministrador.id;
}

/** Verifica se o perfil informado é igual ao perfil Representante */
export function isPerfilRepresentante(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilRepresentante.id;
}

/** Verifica se o perfil informado é igual ao perfil Gerente */
export function isPerfilGerente(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilGerente.id;
}

/** Verifica se o perfil informado é igual ao perfil Atendente */
export function isPerfilAtendente(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilAtendente.id;
}


/** Verifica se o perfil informado é igual ao perfil Expedição */
export function isPerfilExpedicao(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilExpedicao.id;
}

/** Verifica se o perfil informado é igual ao perfil Financeiro */
export function isPerfilFinanceiro(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilFinanceiro.id;
}


/** Verifica se o perfil informado é igual ao perfil PCP */
export function isPerfilPCP(idPerfil: number): boolean {
    if (!idPerfil) {
        return false;
    }
    return idPerfil === usuarioPerfilPCP.id;
}
